export default __webpack_public_path__ + "static/media/three-dots.69007f75.svg";